import React from 'react'
import Rubrique from '../../Component/Gestion/Rubrique'
import Famille from '../../Component/Gestion/Famille'
import Critere from '../../Component/Gestion/Critere'
import Onglet from '../../Component/Gestion/Onglet'
import Grid from '@material-ui/core/Grid/Grid'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'


export default (class extends React.Component {

  state = {
    UserTabSelected: 0,
    busGUID: Utils.uuidv4()
  }

  crmConfiguration = [
    {
      component: <Rubrique />
    },
    {
      component: <Famille />
    },
    {
      component: <Critere />
    },
    {
      component: <Onglet />
    },
  ]


  componentWillUnmount() {
    Bus.$off('donnees_annexes_gestion', this.state.busGUID)
  }

  componentDidMount() {
    Bus.$on('donnees_annexes_gestion', id => {
      this.setState({ UserTabSelected: id })
    }, this.state.busGUID)
  }

  render() {
    return <Grid container style={{ margin: 0, padding: 0, width: '100%' }} spacing={0}>
      <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
        {
          this.crmConfiguration[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Gestion/index.js